
import markerSDK from "@marker.io/browser";

interface MarkerConfig {
  destination: string;
  customData: {
    version: string;
    [key: string]: string | number | boolean;
  };
}

/**
 * Configures and loads the Marker.io widget
 * with the specified destination ID and custom data
 */
const configureMarkerIO = (config: {
  destinationId?: string;
  version: string;
}): void => {
  const markerConfig: MarkerConfig = {
    destination: config.destinationId || '652166c9032c6c6080b704c3',
    customData: {
      version: config.version,
    },
  };

  markerSDK.loadWidget(markerConfig);
};

export default configureMarkerIO;
